import React from 'react';
import { cn } from '@/lib/utils';
type CTAButtonProps = {
  children: React.ReactNode;
  className?: string;
  fullWidthMobile?: boolean;
};
export function CTAButton({
  children,
  className = '',
  fullWidthMobile = true
}: CTAButtonProps) {
  return <a href="https://le-protocole-clinique.impultienda.ar/checkout" className={cn(['group inline-flex items-center justify-center gap-2 rounded-full bg-grass px-8 py-5 text-base font-extrabold uppercase tracking-wide text-black shadow-lg shadow-grass/20 transition-all duration-200 hover:bg-grass-dark hover:scale-[1.02] active:scale-100 sm:text-lg', fullWidthMobile ? 'w-full sm:w-auto' : '', className].join(' '), 'pt-[2px] pb-[2px] pl-[1px] pr-[1px] gap-[5px]')} data-id="element-63">
      {children}
    </a>;
}